import createContextProxy from 'src/state/context/contextProxy'
import type { GroupContextType } from './GroupsProviders'

const groupStateProvider = createContextProxy<GroupContextType>('Groups')

export const GroupStateContext = groupStateProvider.ContextProxy
export const GroupStateProvider = groupStateProvider.ContextProxyProvider
export const useGroupState = groupStateProvider.useProxy
